<template>
  <div class="demand">
    <div class="searchPart">
      <el-input v-model="nickname" placeholder="设计师昵称"></el-input>
      <!--<el-input v-print="designerAdd" placeholder="设计师地址"></el-input>-->
      <el-button class="searchBtn" @click="search">搜索</el-button>
      <el-button type="text" class="resetBtn" @click="reset">
        <i class="iconfont icon-qingchushujuku"></i>
        <span>清除条件</span>
      </el-button>
    </div>
    <div class="tablePart">
      <div class="tableTool">
        <div class="toolLeft">
          <span
            >已选： <span class="num">{{ demandSelection.length }}</span></span
          >
          <el-button
            type="primary"
            plain
            size="small"
            @click="del('all')"
            :disabled="demandSelection.length > 0 ? false: true"
            >批量取消</el-button
          >
        </div>
      </div>
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange"
        class="tableContent"
      >
        <el-table-column
          type="selection"
          header-align="center"
          align="center"
          width="55"
        >
        </el-table-column>
        <el-table-column
          label="设计师昵称"
          header-align="center"
        >
          <template slot-scope="scope">
            <div class="printImgsName">
              <a :href="$url.threeWeb+'/designModel/'+scope.row.designer_uuid"  target="_blank">
              <img :src="scope.row.likeInfo.headUrl" alt="" v-if="scope.row.likeInfo.headUrl">
              <img src="../../assets/users.png" alt="" v-if="!scope.row.likeInfo.headUrl"  >
              </a>
              <div class="printImgsNameMess">
                  <h4><a :href="$url.threeWeb+'/designModel/'+scope.row.designer_uuid"  target="_blank">{{ scope.row.likeInfo.nickname }}</a></h4>
                <div class="printImgsNameMessNum">
                  <p>作品 <span>{{ scope.row.likeInfo.productionNum == null ? 0 : scope.row.likeInfo.productionNum}}</span> </p>
                  <i></i>
                  <p>粉丝 <span>{{ scope.row.likeInfo.fans == null ? 0 : scope.row.likeInfo.fans}}</span> </p>
                  <i></i>
                  <p>订单 <span>{{ scope.row.likeInfo.orderNum == null ? 0 : scope.row.likeInfo.orderNum}}</span> </p>
                  <!--<i></i>-->
                  <!--<p>好评率 <span>98%</span> </p>-->
                </div>
                <div class="title-con">
                     <p class="title" >{{ scope.row.likeInfo.introduction }}</p>
                </div>
                <p class="titles">{{ scope.row.likeInfo.introduction }}</p>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="likeInfo.address"
          label="地址"
          header-align="center"
          align="center"
          width="330"
          :formatter="formatAddr"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          header-align="center"
          align="center"
          width="230"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="del(scope.row.uuid)">取消关注</el-button>
          </template>
        </el-table-column>
        <template slot="empty">
          <img src="../../assets/暂无关注.jpg" alt="" style="width:200px">
        </template>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        @prev-click="handleCurrentChange"
        @next-click="handleCurrentChange"
        layout="total,prev, pager, next,jumper"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="total"
        class="pagination"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {deleteCollects,getCollectListByMap} from '../../utils/interface';
export default {
  data() {
    return {
      form: {},
        nickname: "",
      designerAdd: "",
      tableData: [
      ],
      pageNo: 0,
      pageSize: 10,
      total: 1000,
      demandSelection: [],
    };
  },
    computed: {
        ...mapState({}),
    },
    mounted() {
        this.getList()
    },
  methods: {
      formatAddr: function (row, column) {
          let addr = "";
          if (row.likeInfo.city === row.likeInfo.district) {
              addr = row.likeInfo.province+row.likeInfo.city+row.likeInfo.address;
          } else {
              addr = row.likeInfo.province+row.likeInfo.city+row.likeInfo.district+row.likeInfo.address;
          }
          return addr;
      },
    // 清除检索条件
    reset() {
      this.nickname = "";
      this.designerAdd = "";
    },
      // 获取列表
      getList() {
          let data = {
              current: this.pageNo,
              pageSize: this.pageSize,
              likeType: 'DESIGNER',
              nickname: this.nickname
          }
          getCollectListByMap(data).then((res) => {
              this.tableData = res.list
              this.total = res.total
              this.pageNo = res.current
              console.log(this.tableData)
          })
      },
    // 分页
    handleCurrentChange(val) {
      this.pageNo = val;
        this.getList()
    },
    // 复选框选中值
    handleSelectionChange(val) {
      this.demandSelection = val;
    },
      search() {
          this.pageNo = 1
          this.getList()
      },
      // 删除
      del(val){
          let ids = [];
          if(val === 'all'){
              this.demandSelection.forEach((item)=>{
                  ids.push(item.uuid);
              });
          } else {
              ids.push(val)
          }
          console.log(ids);
          this.$confirm('确定要执行当前操作吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              deleteCollects(ids).then((res) => {
                  console.log(res);
                  if(res.success){
                      this.$message({
                          type: 'success',
                          message: '操作成功！'
                      })
                      this.getList();
                  }
              });
          }).catch(() => {})
      },
  },
};
</script>

<style scoped lang="less">
.demand {
  padding: 20px;

  .releaseBox {
    background: #fff;
    padding: 35px;
    padding-top: 0;
    box-sizing: border-box;
    .releaseBoxTop {
      margin-bottom: 15px;
      h4 {
        font-size: 18px;
        color: #157efa;
        margin-bottom: 18px;
      }
      .releaseBoxTopInput {
        font-size: 14px;
        color: #262626;
        align-items: center;
        margin-bottom: 20px;
        /deep/.ql-toolbar.ql-snow {
          display: none;
        }
        /deep/.ql-toolbar.ql-snow + .ql-container.ql-snow {
          border-top: 1px solid #ccc;
        }
        .releaseBoxTopInputBox {
          flex-wrap: wrap;
        }
        input {
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          padding-left: 8px;
          box-sizing: border-box;
        }
        .input2 {
          width: 161px;
          // margin-left: 90px;
        }
        textarea {
          width: 614px;
          height: 206px;
          background: #f5f5f5;
          opacity: 1;
          border-radius: 6px;
          border: none;
          padding: 8px;
          box-sizing: border-box;
        }
        /deep/.el-input--prefix .el-input__inner {
          width: 161px;
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          //   padding-left: 8px;
          box-sizing: border-box;
          //   margin-left: 25px;
        }
        // /deep/.el-input__prefix {
        //   right: -132px;
        //   left: 0;
        // }
        /deep/.el-input__icon {
          line-height: 30px;
        }
        .releaseBoxbotInputP {
          width: 94px;
          flex-shrink: 0;
          white-space: nowrap;
        }
        .releaseBut {
          background: #157efb;
          color: #fff;
        }
        button {
          width: 100px;
          height: 30px;
          background: #f5f5f5;
          border-radius: 4px;
          border: none;
          margin-right: 20px;
          color: #262626;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }
  }

  .searchPart {
    display: flex;
    flex-wrap: wrap;

    /deep/ .el-input {
      width: initial;
      margin-bottom: 22px;
      margin-right: 30px;
    }

    /deep/ .el-input__inner {
      width: 242px;
      height: 35px;
      min-height: 35px;
      font-size: 12px;
      color: #999999;
      background-color: #f2f4f7;
      border: 1px solid #f2f4f7;
      border-radius: 5px;

      &:hover,
      &:focus {
        background-color: #fff;
        border: 1px solid #108ee9;
      }
    }

    /deep/ .el-input__prefix {
      top: -3px;
    }

    /deep/ .el-input__suffix {
      top: 2px;
    }

    /deep/ .el-button {
      display: block;
      line-height: 35px;
      padding: 0;
      height: 35px;
    }

    .searchBtn {
      width: 82px;
      background: #3d7fff;
      border: none;
      border-radius: 15px;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 22px;
    }

    .resetBtn {
      color: #333333;
      margin-bottom: 22px;
    }
  }

  .tablePart {
    .tableTool {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;

      .toolLeft {
        font-size: 12px;
        color: rgba(0, 0, 0, 0.847);

        .num {
          color: #356fdf;
        }

        button {
          padding: 0;
          margin-left: 15px;
          width: 80px;
          height: 30px;
          background: rgba(242, 244, 247, 1);
          box-sizing: border-box;
          border: 1px solid rgba(21, 126, 251, 1);
          border-radius: 5px;
          font-size: 12px;
          color: #157efb;
          line-height: 30px;
          text-align: center;

          &:hover {
            background: #157efb;
            box-sizing: border-box;
            border: 1px solid #157efb;
            color: #fff;
          }
        }
      }

      .toolRight {
        button {
          width: 83px;
          height: 30px;
          background: rgba(21, 126, 251, 1);
          border: none;
          border-radius: 15px;
          font-size: 13px;
          color: #fff;

          i {
            padding-right: 5px;
          }

          &:hover {
            background: #61a2f0;
          }
        }
      }
    }

    .tableContent {
      min-height: 650px;
      .printImgsName {
        display: flex;
        align-items: center;
        // position: relative;
        img {
          margin-right: 10px;
          width: 80px !important;
          height: 80px !important;
          border-radius: 50%;
        }
        .title-con{
          width: 600px;
          // position: relative;
          cursor: pointer;
        }
    
        .printImgsNameMess:hover .titles{
            display: block;
        }
        .printImgsNameMess {
          position: relative;
          .titles{
                position: absolute;
                bottom: 30px;
                z-index: 999999;
                background: black;
                padding: 5px 10px;
                width: 500px;
                color: white;
                display: none;
          }
          h4 {
            margin: 0;
          }
          p {
            margin: 0;
          }
          .title{
              width: 600px;
              overflow: hidden;
             text-overflow: ellipsis;
             white-space: nowrap;
             cursor: pointer;
            }
          
          .printImgsNameMessNum {
            display: flex;
            align-items: center;

            p {
              margin: 5px 0;
              span {
              color: #108ee9;
            }
            }

            i {
              display: inline-block;
              width: 1px;
              height: 14px;
              background: #ccc;
              margin: 0 8px;

            }
          }
        }
      }
      /deep/ .el-table__header {
        tr {
          th {
            border-right: none;
          }
        }

        /deep/ .el-table__cell {
          padding: 5px 0;
          background: #f2f5fc;
        }
      }

      /deep/ .el-table__body {
        img {
          vertical-align: middle;
          width: 52px;
          height: 50px;
        }

        /deep/ .el-table__row {
          td:first-child {
            border-right: none;

            .cell {
              padding-left: 15px;
            }
          }
        }
      }
    }

    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }
}
/deep/.el-dialog__body {
  padding-top: 0;
}
.itemFlex {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
  .name {
    margin-left: 10px;
    /deep/p {
      margin: 0 !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/focusOn/designerFocus.vue